import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { OneOffIncomePaymentModel } from "../../../../../Wrap/Models/Models/Processes/Drawdown/OneOffIncomePaymentModel";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { IStepConfig, StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { IncomePaymentOneOffAction } from "./Actions/IncomePaymentOneOffAction";
import { IncomePaymentOneOffDetail } from "./Components/IncomePaymentOneOffDetail";
import { IncomePaymentOneOffReview } from "./Components/IncomePaymentOneOffReview";
import { incomePaymentOneOffSteppersMap, NewIncomePaymentContent } from "./Resource/Content";
import { IncomePaymentOneOffStore } from "./Store/Variable";
import { Action } from "../../../Actions/Action";
import { IncomePaymentOneOffDocumentsAndDeclarations } from "./Components/IncomePaymentOneOffDocumentsAndDeclarations";

interface INewIncomePaymentOneOffWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
}

export class NewIncomePaymentOneOffWizard extends AccountContextWizardComponent<INewIncomePaymentOneOffWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(IncomePaymentOneOffStore, () => this.onInstructionStoreChange());
    }

    private onInstructionStoreChange() {
        if (IncomePaymentOneOffStore.getActionType() == ActionType.Success) {
            const data = IncomePaymentOneOffStore.getData();
            this.setState({
                isLoading: false,
                data: data,
            });
        }
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();

        Action.getBankAccounts(params["hierarchyid"], (result) => {
            this.setState({
                extraInfo: { AllBankAccounts: result }
            }); 
        });

    }

    componentDidUpdate() {
        const { customer, clientAccount, data, isRestrictionLoading, extraInfo } = this.state;
        if (customer && clientAccount && !data && !isRestrictionLoading && extraInfo) {
            const id = getQueryParameters()["id"];
            const npr = clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr || x.SubAccountType == SubAccountType.JuniorSipp);
            if (npr) {
                IncomePaymentOneOffAction.getInstruction(
                    id,
                    clientAccount.HierarchyId,
                    npr.HierarchyId,
                    customer.CustomerId
                );
            }
        }
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        if (from == stepLength - 1) {return this.onExit();}
        if (!params["id"]) {params["id"] = this.state.data.HierarchyId;}

        const npr = this.state.clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr || x.SubAccountType == SubAccountType.JuniorSipp);
        IncomePaymentOneOffAction.saveInstruction(from, this.state.data, this.state.data.HierarchyId, this.state.data.CustomerId, npr.HierarchyId, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        // const id = this.getInstructionId();
        // IncomePaymentOneOffAction.deleteInstruction(id, () => this.onExit());
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        const npr = this.state.clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr || x.SubAccountType == SubAccountType.JuniorSipp);
        IncomePaymentOneOffAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.CustomerId,
            npr.HierarchyId,
            () => this.setState({ isSubmitting: false })
        );
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
 
        return stepProps;
    }

    private setReviewConfirmSteppers() {
        return [];
    }

    setStepperConfig() {
        const disableWithdraw = RestrictionStore.WithdrawDisabled()
        const steppers: IStepConfig[] = [
            {
                title: incomePaymentOneOffSteppersMap.incomePaymentOneOffDetail,
                url: Urls.get().IncomePaymentOneOffDetail,
                path: Contents.URLMap.incomePaymentOneOffDetail,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <IncomePaymentOneOffDetail
                        readonly={disableWithdraw}
                        isDisableNextBtn={disableWithdraw} 
                        {...this.getStepProps(0)} 
                        customerId={this.state.customer?.CustomerId} extraInfo={this.state.extraInfo} isLoading={this.state.isLoading} />
                ),
            },
        ];

        steppers.push({
            title: incomePaymentOneOffSteppersMap.incomePaymentOneOffReview,
            url: Urls.get().IncomePaymentOneOffReview,
            path: Contents.URLMap.incomePaymentOneOffReview,
            onStepLeave: (from, to) => {
                this.onStepperLeave(from, to);
            },
            component: <IncomePaymentOneOffReview {...this.getStepProps(1)} customerId={this.state.customer?.CustomerId} extraInfo={this.state.extraInfo} />,
        });
        steppers.push({
            title: incomePaymentOneOffSteppersMap.incomePaymentOneOffDocumentsAndDeclations,
            url: Urls.get().IncomePaymentOneOffDocumentsAndDeclations,
            path: Contents.URLMap.incomePaymentOneOffDocumentsAndDeclations,
            onStepLeave: (from, to) => {
                this.onStepperLeave(from, to);
            },
            needPrint: true,
            onSubmit: () => this.onSubmit(),
            canSubmit: () => this.child[this.stepperConfig.length - 3].isValid(),
            component: <IncomePaymentOneOffDocumentsAndDeclarations {...this.getStepProps(1)} customerId={this.state.customer?.CustomerId} />,
        });

        const data: OneOffIncomePaymentModel = this.state.data;
        const clAccountId = getQueryParameters()["claccountid"];

        steppers.push({
            title: incomePaymentOneOffSteppersMap.incomePaymentOneOffConfirmation,
            url: Urls.get().IncomePaymentOneOffConfirmation,
            path: Contents.URLMap.incomePaymentOneOffConfirmation,
            onStepLeave: (from, to) => {
                this.onStepperLeave(from, to);
            },
            type: StepType.Confirmation,
            component: (
                <Confirmation
                    onExit={() => this.onExit()}
                    successMessage={NewIncomePaymentContent.successMessage(
                        this.state.customer?.PersonalDetails?.Name?.Given ?? "",
                        this.state.customer?.PersonalDetails?.Name?.Family ?? "",
                        clAccountId
                    )}
                    isLoading={this.state.isSubmitting}
                />
            ),
        });

        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "One-off income payment";
        return processProps;
    }
}
